<template>
  <div>
    <transition name="none">
      <div class="shadow" v-if="isOpen"></div>
    </transition>
    <transition name="slide">
      <div class="menu" v-if="isOpen">
        <div class="container">
          <div class="d-flex justify-content-end">
            <div class="close-icon" @click="handleClose">
              <close-icon />
            </div>
          </div>
          <div class="row menu-text">
            <h3>Menu</h3>
          </div>
          <div class="container">
            <router-link
              :to="{ name: 'find-symptoms' }"
              class="menu-link d-flex justify-content-between"
              @click="handleClose"
            >
              <p>Znajdź usterkę</p>
              <wrench-icon fill="gradient" />
            </router-link>
            <router-link
              :to="{ name: 'find-repairs' }"
              class="menu-link d-flex justify-content-between"
              @click="handleClose"
            >
              <p>Znajdź naprawę</p>
              <wrench-icon fill="gradient" />
            </router-link>
            <router-link
              :to="
                getSelectedCar
                  ? {
                      name: 'tec-estimate-list',
                      params: { typeId: getSelectedCar.typeId },
                    }
                  : { name: 'tec-estimate-list-no-car' }
              "
              class="menu-link d-flex justify-content-between"
              @click="handleClose"
            >
              <p>Sprawdź koszt naprawy</p>
              <zloty-icon fill="gradient" />
            </router-link>
            <a
              :href="`tel:${getPhoneNumber}`"
              class="menu-link d-flex justify-content-between"
              @click="handleClose"
            >
              <p>Zapytaj eksperta</p>
              <phone-icon fill="gradient" />
            </a>
            <div class="margin-row"></div>
            <template v-if="user">
              <p>
                Jesteś zalogowany jako
                <span class="bold">{{ user.username }}</span>
              </p>
              <router-link
                :to="{ name: 'profile' }"
                class="menu-link d-flex justify-content-between"
                @click="handleClose"
              >
                <p>Edytuj profil</p>
                <user-icon />
              </router-link>
              <a
                class="menu-link d-flex justify-content-between"
                @click="logout"
              >
                <p>Wyloguj</p>
                <logout-icon />
              </a>
            </template>
            <login-buttons v-else />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import CloseIcon from "@/components/icons/CloseIcon";
import WrenchIcon from "@/components/icons/WrenchIcon";
import ZlotyIcon from "@/components/icons/ZlotyIcon";
import { mapActions, mapGetters } from "vuex";
import PhoneIcon from "@/components/icons/PhoneIcon";
import LoginButtons from "@/accounts/LoginButtons";
import LogoutIcon from "@/components/icons/LogoutIcon";
import UserIcon from "@/components/icons/UserIcon";

export default {
  props: {
    isOpen: {
      type: Boolean,
    },
  },
  methods: {
    handleClose() {
      this.$emit("closeMenu");
    },
    ...mapActions("accounts", ["logout"]),
  },
  computed: {
    ...mapGetters("accounts", ["user", "csrf"]),
    ...mapGetters(["getPhoneNumber", "getSelectedCar"]),
  },
  components: {
    UserIcon,
    LogoutIcon,
    LoginButtons,
    WrenchIcon,
    CloseIcon,
    ZlotyIcon,
    PhoneIcon,
  },
  watch: {
    isOpen() {
      document.body.classList.toggle("noscroll");
    },
  },
};
</script>
<style scoped>
.menu {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  overflow: auto;
}

.close-icon {
  margin-right: 25px;
  margin-top: 25px;
}

.menu-text {
  margin-bottom: 50px;
}

.menu-link {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.container {
  max-width: 840px !important;
}

.shadow {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(1, 1, 1, 0.7);
  z-index: 998;
  overflow: hidden;
}

.margin-row {
  margin-top: 25px;
  margin-bottom: 25px;
  height: 1px;
}

.bold {
  font-weight: bold;
}

.slide-enter-active,
.slide-leave-active {
  transition: left 0.5s ease;
  left: 0;
}

.slide-enter-from,
.slide-leave-to {
  left: 100%;
}

.none-enter-active,
.none-leave-active {
  transition: opacity 0.5s ease;
}

.none-enter-from,
.none-leave-active {
  opacity: 0;
}
</style>
